 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main~d0ae3f07": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + chunkId + "." + {"page-home~page-sponsors~page-talents-world~b8ccc773":"1f4ba5a9f7d235ea7c7c","page-sponsors~b07b7304":"586a7dd9e3810bd08906","npm.moment-mini~751b3068":"e42ef7e297c6f7737776","page-teaser~493df0b3":"988a99777fbaade4c52d","npm.pixi~034b9bf7":"1a762e4af10a56cf6b0d","npm.ismobilejs~c131a20c":"0bf9e487c324c8f50203","npm.pixi.js~a8b7ab42":"6450e11c70d96a26cb65","npm.earcut~278d7a19":"42625ab99f220ed409c9","npm.es6-promise-polyfill~95a2069f":"3bd2490d60d7c3904128","npm.eventemitter3~431d11f4":"e3bdfea1fe7df5bf9252","npm.mini-signals~955bf80b":"5494a0019ab826fffa65","npm.object-assign~d690d634":"8fd352be0bbb65fd84d9","npm.parse-uri~bdc83086":"29a3cd9cb3dac75d100e","npm.resize-observer-polyfill~40b3a84b":"02d7e57979455b1073eb","npm.resource-loader~4f97ddad":"503723bee1127d99ac77","npm.fontfaceobserver~4eaee99e":"a1a31dc4a266050739b5","page-about~page-designer~page-designers~page-home~page-illustrators~page-initiatives-article~page-in~0e27d97a":"7cd8a50259034cb8b615","page-home~page-new-designers~bf1eb8a7":"ac4e8ae3772e0c39aa67","page-home~f71cff67":"f2a9881c87f5577f88aa","npm.get-src~ed2eae31":"d81d4e028edcf8b2114a","npm.get-video-id~28f26eec":"35d2898a588e58974a25","page-invitation~f71cff67":"8fdd671585d38672485f","page-designer~page-illustrators~page-initiatives-article~page-initiatives-details~page-media~page-ne~9aebf630":"0729b85c20a7340ec4f4","page-designer~page-illustrators~page-initiatives-article~page-initiatives-details~page-new-designers~a34bf6db":"53bf49f953ca5639970c","page-about~page-designer~page-initiatives-article~page-initiatives-details~page-new-designers~2a7aac~4a8883cf":"f00b714204199e215ff6","page-designer~page-initiatives-article~page-initiatives-details~page-new-designers~page-sponsor-xiao~5f987d8d":"378d573ecdb029bbdc63","page-designer~page-initiatives-article~page-initiatives-details~page-new-designers~5ed72fcf":"eeb1122a95b756f50ed6","page-designers~page-initiatives~page-media~page-new-designers~b8ccc773":"00991611bedea894507e","page-illustrators~page-new-designers~page-sponsor-xiaomi~page-talents-world~e3758232":"18e99efe5f1817ae8b52","page-illustrators~page-initiatives-details~page-new-designers~62b96e1c":"269e71a932e581bfc533","page-new-designers~f71cff67":"9bb19e015579853418ea","page-designer~page-designers~0acc5b6d":"f96d3976da9371b07092","page-designer~b07b7304":"7f0de93bc8b136f3fc83","page-initiatives-article~page-initiatives-details~e103a032":"3add729cd395e3e642d6","page-initiatives~page-initiatives-details~4628ef7e":"63c82a63151d42fc58c8","page-initiatives-details~f71cff67":"26362e0da22c17e21ad2","page-initiatives-article~b07b7304":"ef6fe7b5af529c609ade","page-talents-world~b07b7304":"b67df37385a8e72b8f21","page-illustrators~f71cff67":"cf8cd1f82d189de41097","page-media~b07b7304":"3d05afab019b3eb9d913","page-about~f71cff67":"8cc185ba6c5ed56a4569","page-designers~f71cff67":"e69b0369423f24e5f3a9","page-initiatives~f71cff67":"83ec578f3eea4c8d6827","page-sponsor-xiaomi~f71cff67":"e64d81c55c6b42fc788d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.vuetify~7a09b6f7","npm.lodash~38a85cf5","npm.vuetify-loader~30af36f2","npm.core-js~41983590","npm.aws-sdk~a8b4667e","npm.axios~b9b6cea2","npm.babel~113cc294","npm.graphql~191e5755","npm.aws-amplify~8a129e59","npm.amazon-cognito-identity-js~1e0217f9","npm.aws-crypto~a99e5185","npm.crypto-js~0c39ca8d","npm.vue-lottie~6fe93b48","npm.splitting~9536bd1d","npm.querystring-es3~259b8229","npm.webpack~ba46a19e","npm.monogrid~c239a5c0","npm.wry~2d08c264","npm.apollo-link-state~aa7da406","npm.css-loader~6aded061","npm.graphql-anywhere~0eef080e","npm.node-libs-browser~591bd453","npm.symbol-observable~6e20a0c1","npm.url~f0eea272","npm.vue-style-loader~e7643cb0","npm.zen-observable~7333b33f","npm.animejs~71e33846","npm.apollo-cache-inmemory~3d3f419c","npm.apollo-cache~ec16e518","npm.apollo-client~d00b6b88","npm.apollo-link-batch-http~c1df0dbb","npm.apollo-link-batch~f1c6b407","npm.apollo-link-error~a34b6b60","npm.apollo-link-http-common~8a9e1bde","npm.apollo-link~1e28f5e6","npm.apollo-utilities~3fba4b84","npm.vue-apollo~41d41d87","npm.vue-meta~c8d98bf7","npm.vue-plyr~b8937962","npm.base64-js~542cf665","npm.console-polyfill~09cfb864","npm.deepmerge~11c11368","npm.fast-json-stable-stringify~671c6240","npm.graphql-tag~e5721fa3","npm.howler~cd8c17c8","npm.ieee754~2f106160","npm.intersection-observer~79123a75","npm.isarray~93ecf554","npm.js-cookie~6f943d3f","npm.lottie-web~63fa2f35","npm.optimism~83dbe205","npm.plyr~1188a278","npm.process~e979afec","npm.regenerator-runtime~84d0a99a","npm.ts-invariant~8e2c0eb2","npm.tslib~0353a882","npm.vue-axios~42e5ce89","npm.vue-event-handler~958acfd8","npm.vue-gettext~733cbc2c","npm.vue-gtm~3a225059","npm.vue-loader~3d84837a","npm.vue-router~4d830cd8","npm.vue~0dd8155b","npm.whatwg-fetch~0d45f70b","npm.zen-observable-ts~26b613ba"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
